import revive_payload_client_4sVQNw7RlN from "C:/Users/ngngo/Projects/ft_hts_fe/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "C:/Users/ngngo/Projects/ft_hts_fe/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "C:/Users/ngngo/Projects/ft_hts_fe/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "C:/Users/ngngo/Projects/ft_hts_fe/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "C:/Users/ngngo/Projects/ft_hts_fe/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "C:/Users/ngngo/Projects/ft_hts_fe/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "C:/Users/ngngo/Projects/ft_hts_fe/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "C:/Users/ngngo/Projects/ft_hts_fe/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "C:/Users/ngngo/Projects/ft_hts_fe/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "C:/Users/ngngo/Projects/ft_hts_fe/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_AUP22rrBAc from "C:/Users/ngngo/Projects/ft_hts_fe/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.js";
import index_nvxxlQHv7t from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/directives/index.ts";
import index_oZn97iQatL from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/i18n/index.ts";
import index_7YHjX7nBB3 from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/socket/index.ts";
import formatters_wHo49XFvHj from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/formatters.ts";
import colors_ah3F7k3H32 from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/colors.ts";
import data_table_ty3W76TeD9 from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/data-table.ts";
import dayjs_NBCB9zH19f from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/dayjs.ts";
import diacritic_QjQiTCB0R8 from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/diacritic.ts";
import disable_reactive_FxEJ5xLbIt from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/disable-reactive.ts";
import draggable_KxFBN6qbBL from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/draggable.ts";
import event_bus_2B8uO4OVrn from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/event-bus.ts";
import event_G8mb4bhOk1 from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/event.ts";
import headlessui_Se9S4aEwS6 from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/headlessui.ts";
import heroicons_GCe3RtOpr2 from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/heroicons.ts";
import journey_mZfMfCNsph from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/journey.ts";
import location_EC3HOihKAa from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/location.ts";
import lodash_OLcv4NeO3J from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/lodash.ts";
import search_objects_2mPvuUw5XS from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/search-objects.ts";
import tippy_NE7EbmCUgf from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/tippy.ts";
import toastification_KMMkhG88sR from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/toastification.ts";
import trip_bpqEIBeZRV from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/trip.ts";
import vee_validate_fgGHHmjH3T from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/vee-validate.ts";
import vehicle_gps_9KfWXq73X8 from "C:/Users/ngngo/Projects/ft_hts_fe/src/plugins/vehicle-gps.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_AUP22rrBAc,
  index_nvxxlQHv7t,
  index_oZn97iQatL,
  index_7YHjX7nBB3,
  formatters_wHo49XFvHj,
  colors_ah3F7k3H32,
  data_table_ty3W76TeD9,
  dayjs_NBCB9zH19f,
  diacritic_QjQiTCB0R8,
  disable_reactive_FxEJ5xLbIt,
  draggable_KxFBN6qbBL,
  event_bus_2B8uO4OVrn,
  event_G8mb4bhOk1,
  headlessui_Se9S4aEwS6,
  heroicons_GCe3RtOpr2,
  journey_mZfMfCNsph,
  location_EC3HOihKAa,
  lodash_OLcv4NeO3J,
  search_objects_2mPvuUw5XS,
  tippy_NE7EbmCUgf,
  toastification_KMMkhG88sR,
  trip_bpqEIBeZRV,
  vee_validate_fgGHHmjH3T,
  vehicle_gps_9KfWXq73X8
]